import {
  jb_button_panel_css_default
} from "./chunk.NL3GJDQ3.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-button-panel/jb-button-panel.ts
var JbButtonPanel = class extends r {
  constructor() {
    super(...arguments);
    this.align = "left";
  }
  render() {
    this.align = this.align || "left";
    return ke`<div class=${Rt({ [`${this.align}-aligned`]: true })}>
      <slot></slot>
    </div>`;
  }
};
JbButtonPanel.styles = [reset_css_default, jb_button_panel_css_default];
__decorateClass([
  n()
], JbButtonPanel.prototype, "align", 2);
JbButtonPanel = __decorateClass([
  customElement("jb-button-panel")
], JbButtonPanel);

export {
  JbButtonPanel
};
